import { configureStore } from "@reduxjs/toolkit";
import lateFeeConfig from "./slices/finance/lateFeeConfig";
import paymentReference from "./slices/finance/paymentReference";
import paymentTransaction from "./slices/finance/paymentTransaction";
import paymentType from "./slices/finance/paymentType";
import schoolbankconfig from "./slices/finance/schoolbankconfig";
import studentDebt from "./slices/finance/studentDebt";
import studentDebtNotification from "./slices/finance/studentDebtNotification";
import login from "./slices/login/login";
import previousPath from "./slices/previousPath";
import report from "./slices/report/report";
import academicPeriod from "./slices/school/academicPeriod";
import assessment from "./slices/school/assessment";
import classes from "./slices/school/classes";
import classroom from "./slices/school/classroom";
import classroomType from "./slices/school/classroomType";
import course from "./slices/school/course";
import courseSubject from "./slices/school/courseSubject";
import departament from "./slices/school/departament";
import enrollmentRequiredDocument from "./slices/school/enrollmentRequiredDocument";
import faculty from "./slices/school/faculty";
import lessonPlan from "./slices/school/lessonPlan";
import manager from "./slices/school/manager";
import scientificArea from "./slices/school/scientificArea";
import student from "./slices/school/student";
import subject from "./slices/school/subject";
import subjectPlan from "./slices/school/subjectPlan";
import subscription from "./slices/school/subscription";
import teacher from "./slices/school/teacher";
import teacherEvaluationCriteria from "./slices/school/teacherEvaluationCriteria";
import teacherRequiredDocument from "./slices/school/teacherRequiredDocument";
import vacancy from "./slices/school/vacancy";
import role from "./slices/users/role";
import user from "./slices/users/user";
import entities from "./slices/scientific/entities";
import subEntities from "./slices/scientific/subEntities";
import exhibitor from "./slices/scientific/exhibitor";
import exhibitorsProjects from "./slices/scientific/exhibitorsProjects";
import judges from "./slices/scientific/judges";
import judgePhaseProjects from "./slices/scientific/judgePhaseProjects";
import judgePhaseProjectDocuments from "./slices/scientific/judgePhaseProjectDocuments";
import projects from "./slices/scientific/projects";
import phases from "./slices/scientific/phases";
import projectExpenses from "./slices/scientific/projectExpenses";
import projectTypes from "./slices/scientific/projectTypes";
import projectsDocuments from "./slices/scientific/projectsDocuments";
import paymentMethod from "./slices/finance/paymentMethod";
import category from "./slices/library/category";
import author from "./slices/library/author";
import book from "./slices/library/book";
import bookAuthor from "./slices/library/bookAuthor";
import loan from "./slices/library/loan";
import reservation from "./slices/library/reservation";
import coursePayment from "./slices/finance/coursePayment";
import processModel from "./slices/finance/processModel";
import university from "./slices/school/university";
import knowledgeDomain from "./slices/school/knowledgeDomain";
import knowledgeSubDomain from "./slices/school/knowledgeSubDomain";
import academicLevel from "./slices/school/academicLevel";
import formationArea from "./slices/school/formationArea";
import studentSituation from "./slices/school/studentSituation";
import coursePlan from "./slices/school/coursePlan";
import scholarshipType from "./slices/school/scholarshipType";
import scholarshipProvider from "./slices/school/scholarshipProvider";
import scholarship from "./slices/school/scholarship";
import planSubject from "./slices/school/planSubject";
import loaderController from "./slices/loaderController";

const store = configureStore({
    reducer: {
        login,
        user,
        role,
        report,
        faculty,
        departament,
        course,
        scientificArea,
        academicPeriod,
        subject,
        enrollmentRequiredDocument,
        teacher,
        student,
        teacherRequiredDocument,
        classes,
        assessment,
        classroom,
        classroomType,
        vacancy,
        teacherEvaluationCriteria,
        subscription,
        subjectPlan,
        courseSubject,
        lessonPlan,
        manager,
        previousPath,
        lateFeeConfig,
        paymentType,
        paymentMethod,
        studentDebt,
        paymentTransaction,
        paymentReference,
        studentDebtNotification,
        schoolbankconfig,
        entities,
        subEntities,
        exhibitor,
        exhibitorsProjects,
        judges,
        judgePhaseProjects,
        judgePhaseProjectDocuments,
        phases,
        projects,
        projectExpenses,
        projectTypes,
        projectsDocuments,
        category,
        author,
        book,
        bookAuthor,
        loan,
        reservation,
        coursePayment, 
        processModel, 
        university, knowledgeDomain, knowledgeSubDomain,academicLevel,formationArea,
        studentSituation,
        coursePlan,
        scholarshipType, scholarshipProvider, scholarship,
        planSubject,
        loaderController
    },
})

export default store;

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch